/**
 * useMonedas
 *
 */
import React from 'react'
import Api from '../../../Api'
import Exception from '../../../Exception'

/**
 *
 * @returns
 */
function queryRecords() {
  return Api.query({
    model: 'AlmMoneda',
    attributes: [
      'iId',
      'sNombre',
      'iLocal',
    ],

    where: {
      iActivo: true
    },
    order: [
      ['iId', 'DESC']
    ]
  })
}

/**
 *
 */
export function useMonedas() {
  const [loading, setLoading] = React.useState(false)
  const [records, setRecords] = React.useState([])

  const fetch = (search) => {
    queryRecords(search)
      .then(res => {
        setLoading(false)
        setRecords(res.data)
      })
      .catch(err => {
        setLoading(false)
        Exception.load(err).show()
      })
  }

  return {
    loading,
    records,
    fetch,
  }
}
